
/**
 * Tabella PROVVISORIA che associa l'INDEX di un allarme al suo tipo/descrizione.
 * L'INDEX è il numero progressivo presente nel nome della variabile PLC
 * (es. "AAL006_Used" -> index "006", "DAL003_Enabled" -> index "003").
 * TODO: sostituire con la mappatura definitiva.
 */



export const ALARM_ANALOG_TYPE: Record<string, string> = {
	"000": "PH MEASURE THRESHOLD 01",
	"001": "PH MEASURE THRESHOLD 02",
	"002": "EC MEASURE THRESHOLD 01",
	"003": "EC MEASURE THRESHOLD 02",
	"004": "ROOM TEMPERATURE THRESHOLD 01",
	"005": "ROOM TEMPERATURE THRESHOLD 02",
}

export const ALARM_DIGITAL_TYPE: Record<string, string> = {
	"000": "TANK N1 LEVEL MAX",
	"001": "TANK N1 LEVEL MIN",
	"002": "24V DC POWER FAULT",
	"003": "BATTERY LOW VOLTAGE",
	"004": "IRRIGATION PUMP LOW PRESSURE ON IRRIGATION",
	"005": "IRRIGATION PUMP LOW PRESSURE ON MIXING",
	"006": "TANK ACID LEVEL MIN",
	"007": "TANK BASE LEVEL MIN",
	"008": "TANK SOL A LEVEL MIN",
	"009": "TANK SOL B LEVEL MIN",
	"010": "LITERS COUNTER FAULT",
	"011": "IRRIGATION PUMP HIGH PRESSURE",
	"012": "NDS SYSTEM NOT IN AUTOMATIC MODE",
	"013": "ADJUSTMENTS SYSTEM NOT IN AUTOMATIC MODE",
	"014": "IRRIGATION SYSTEM NOT IN AUTOMATIC MODE",
	"015": "LIGHTING SYSTEM NOT IN AUTOMATIC MODE",
	"016": "RELAUNCH SYSTEM NOT IN AUTOMATIC MODE",
	"017": "RELAUNCH TIMEOUT ON LEVEL MIN SENSOR",
	"018": "RELAUNCH TIMEOUT ON LEVEL MAX SENSOR",
	"019": "TANK ACID PUMP THERMAL PROTECTION",
	"020": "TANK BASE PUMP THERMAL PROTECTION",
	"021": "TANK SOL A PUMP THERMAL PROTECTION",
	"022": "TANK SOL B PUMP THERMAL PROTECTION",
	"023": "RELAUNCH PUMP POWER THERMAL PROTECTION",
	"024": "DRAINAGE VACUUM REQUEST FAILURE",
	"025": "IRRIGATION PUMP THERMAL PROTECTION",
	"026": "CABINET MAIN SWITCH OFF",
	"027": "DRAINAGE VALVE OPENING FAILURE",
	"028": "DRAINAGE VALVE CLOSING FAILURE",
	"029": "WATERKEEPER MAXIMUM ADD QUANTITY REACHED",
	"030": "WATERKEEPER REFILL TIMEOUT",
	"031": "ROOM TEMPERATURE TOO HIGH",
	"032": "ROOM HUMIDITY TOO HIGH",
	"033": "HVAC COMMUNICATION ERROR",
}
